import React, { useState, useRef, useEffect, useContext } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {  IconButton, TextField, Stack,InputAdornment } from '@mui/material';
import { Box, Typography, useTheme } from '@mui/material';
import { ColorModeContext, tokens } from "../../../theme/theme";
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import Closeicon from '@mui/icons-material/Close';
import SearchIcon from "@mui/icons-material/Search";
// import  { API_ENDPOINTS } from '../../../config/api/apiCall"';
import CustomSnackbar from '../../../components/CustomSnackbar';
import { API_ENDPOINTS } from '../../../config/api/apiCall';

const ProductItemList = ({ closePopup,onSubmit }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertsevierity, setalertsevierity] = useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };
  const showSnackbar = () => {
    setSnackbarOpen(true);
  };

  // Sample data
  const rows = [
    { id: 1, name: 'John Doe', age: 25 },
    { id: 2, name: 'Jane Smith', age: 30 },
    // Add more rows as needed
  ];
  const [FinancierYear, setf] = useState(1);
  const [CompanyID, setc] = useState(1);
  const masterGroup = 'PRODUCT_ITEM';
  const [filteredData, setFilteredData] = useState([]);

  const [tableData, setTableData] = useState([]);
  // State to track selected rows
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]); 

  // Handler for button click to get details of selected rows
  const handleButtonClick = () => {
    const selectedRowDetails = rows.filter((row) => selectedRows.includes(row.id));
    console.log('Selected Row Details:', selectedRowDetails);
  };

  const handleButtonAction = () => {
    // Your logic to process selected rows
    const result = selectedRows.map(row => ({
      CodeId: row.codeid,
      id: row.id
    }));

    // Combine the results into a single string
    const combinedResult = result.map(entry => `${entry.CodeId}`).join(', ');
    onSubmit(combinedResult);   
    closePopup();
  };

  const [searchText, setSearchText] = useState('');

  const SearchOrder = () => {
    const filter = {
      FinancierYear: FinancierYear,
      CompanyID: CompanyID,
      masterGroup: masterGroup
    };

    fetch(API_ENDPOINTS.getProductItemList, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filter),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('unable to filter product item list');
        }
        return response.json();
      })
      .then(data => {
        const formattedData = data.map((row, index) => ({ ...row, id: index + 1 }));
        setTableData(formattedData);
        //console.log(formattedData);
      })
      .catch(error => {      
        setAlertMessage('unable to filter product item list..!');
        setalertsevierity('error');
        showSnackbar();
      });
  }

  useEffect(() => {
    SearchOrder();
  }, [FinancierYear, CompanyID, masterGroup]);

  useEffect(() => {
    if (tableData.length > 0) {
      const filtered = tableData.filter((row) =>
        Object.values(row).some((value) =>
          value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setFilteredData(filtered);
    }
  }, [searchText, tableData]);

  const columns = [
    // { field: 'CodeId', headerName: 'ID',width:10 },
    { field: 'variety', headerName: 'Variety' },
    { field: 'Item Code', headerName: 'Item Code', width: 200 },
    // { field: 'Item Name', headerName: 'Item Name', hide: true  },
    { field: 'gsm', headerName: 'GSM', width: 50 },
    { field: 'width', headerName: 'Width', width: 50 },
    { field: 'length', headerName: 'Length', width: 50 },
    { field: 'color', headerName: 'Color', width: 80 },
  ];



  const handleKeyPress = (event) => {
    // Check for specific key combinations
    if (event.altKey && event.key.toLowerCase() === 'x') {
      closePopup();
    }
    else if (event.altKey && event.key.toLowerCase() === 'enter') {
      handleButtonAction();
    }
  };

  useEffect(() => {
    // Add the event listener when the component mounts
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [closePopup, handleButtonAction]); // Dependency on closePopup ensures that the effect is re-run if closePopup changes


  return (
    <Box >
       <Stack>
        <CustomSnackbar
          open={snackbarOpen}
          message={alertMessage}
          onClose={handleSnackbarClose}
          type={alertsevierity}
        />
      </Stack>

      <Box display="flex" justifyContent="space-between" alignItems="center">

        <Typography
          variant="h4"
          fontWeight="600"
          color={colors.grey[100]}
          marginBottom={'10px'}
        >
          Product Item List
        </Typography>

        <Box>        
          <Tooltip
            title='Add Selected Products [ Alt + Enter ]'
          >
            <IconButton onClick={handleButtonAction}>
              <AddIcon style={{ color: '#388e3c' }}/>            
            </IconButton>
          </Tooltip>

          <Tooltip title="Close the page [ Alt + x ]">
            <IconButton onClick={closePopup}>
              <Closeicon style={{ color: '#e57373' }} />
            </IconButton>
          </Tooltip>
        </Box>

      </Box>

      <Box
        display="grid"
        gridTemplateColumns="repeat(2, 1fr)"
        gridAutoRows="12px"
        gap="10px"
      >

        {/* ROW 2 */}
        <Box
          gridColumn="span 2"
          gridRow="span 2"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >

          <TextField
            label="Search"
            variant="filled"
            size='small'
            fullWidth
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ marginBottom: '0px', marginTop: '10px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),

            }}

          />

        </Box>
      </Box>

      <Box
        display="grid"
        gridTemplateColumns="repeat(20, 1fr)"
        gridAutoRows="550px"
        gap="0px"
      >

        <Box
          gridColumn="span 20"
          display="flex"
          alignItems="center"
          justifyContent="center"
          m="6px 0 0 0"         
          sx={{
            "& .custom-header": {
              fontWeight: 'bold',  // set bold font
              fontSize: '0.85rem',  // adjust font size                                 
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${colors.grey[100]} !important`,
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <DataGrid
            style={{ marginTop: '15px' }}
            rows={filteredData || []}
            columns={columns}
            checkboxSelection
            rowHeight={33}
            pageSize={5}
            onRowSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = tableData.filter((row) =>
                selectedIDs.has(row.id),
              );
              setSelectedRows(selectedRows);
            }}
          />
       
        </Box>
      </Box>
    </Box>
  );
};

export default ProductItemList;
